import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class User extends React.Component {
  static propTypes = {
    controlIcon: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,

    onSelect: PropTypes.func.isRequired
  }

  handleAction = () => {
    this.props.onSelect(this.props.user);
  }

  render() {
    return (
      <li
        className="user row row-eq-height"
        onClick={this.handleAction}
      >
        <div className="col-xs-5">
          <h5>
            {this.props.user.name}
          </h5>
        </div>

        <div className="col-xs-6 text-muted">
          {this.props.user.officeName}
        </div>

        <div className="col-xs-1 text-center text-primary">
          <FontAwesomeIcon
            className="clickable"
            icon={this.props.controlIcon}
            size="lg"
          />
        </div>
      </li>
    );
  }
}

export default User;
